import { Box } from '@mui/system';
import { MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { type Company } from 'src/utils/type';

export default function CompanySelect ({
  isMobile,
  companies,
  selectedCompany,
  setSelectedCompany,
  handleCompanyChange,
}: {
  isMobile: boolean;
  companies: Company[];
  selectedCompany: Company;
  setSelectedCompany: (company: Company) => void;
  handleCompanyChange: (value: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <Box display="flex" alignItems="flex-start" marginBottom={'24px'}>
      <label>
        {t('Company')}<sup>*</sup>:
      </label>
      <Box display="flex" flex="1" flexWrap="wrap" flexDirection={isMobile ? 'column' : 'row'}>
        <Select
          onChange={e => {
            const companyId = e.target.value;
            const company = companies.find(company => company.cid === companyId);
            handleCompanyChange(companyId);
            setSelectedCompany(company);
          }}
          value={selectedCompany ? selectedCompany.cid : ''}
        >
          {companies.map(company => (
            <MenuItem key={company.cid} value={company.cid}>
              {company.company_name}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
}
